import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { computed, useAttrs, inject } from "vue";
import { ProvideTable } from "./Table.vue";


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Td',
  setup(__props) {

const table = inject<ProvideTable>("table", {
  dark: false,
  bordered: false,
  hover: false,
  striped: false,
  sm: false,
});

const attrs = useAttrs();

const computedClass = computed(() =>
  twMerge([
    "px-5 py-3 border-b dark:border-darkmode-300",
    table?.dark && "border-slate-600 dark:border-darkmode-300",
    table?.bordered && "border-l border-r border-t",
    table?.sm && "px-4 py-2",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})